"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = handleError;
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Scroll Top Handler
 * - Scrolls the enclosing page to the top
 *
 * @module core-bootstrap-scroll-top-handler
 */

/**
* Handles a bootstrap error
*
* @param {string} errStr The error string
* @param {*} config  A config object with various logging flags
*/
function handleError(errStr, config) {
  var logged = false;
  if (config && config.callbacks && config.callbacks.general) {
    // invoke general.error callback if it is provided
    if (config.callbacks.general.error) {
      var data = {
        error_message: 'CORE SDK BOOTSTRAP ERROR: ' + errStr
      };
      config.callbacks.general.error(data);
      logged = true;
    }

    // also invoke general.log callback if it is provided
    if (config.callbacks.general.log) {
      var _data = {
        message: 'CORE SDK BOOTSTRAP ERROR: ' + errStr
      };
      config.callbacks.general.log(_data);
      logged = true;
    }
  }

  // log to console only if we haven't logged to any other source and we
  // either don't have a config object or the config object enables
  // console logging
  if (!logged && console && (!config || config.consoleLoggingEnabled)) {
    console.error('CORE SDK BOOTSTRAP ERROR: ' + errStr); // NOSONAR
  }
}
//# sourceMappingURL=error.js.map